import React from 'react'

export default function Footer() {
    return (
        <footer>
        © 2017-2021 Peter Schaadt Wind 
        </footer>
    )
}
